import script from "./toolbar-form.vue?vue&type=script&setup=true&lang=ts"
export * from "./toolbar-form.vue?vue&type=script&setup=true&lang=ts"

import "./toolbar-form.vue?vue&type=style&index=0&id=74043887&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74043887"]])

export default __exports__